import { LookupSource, createEntireLoadLookupSource } from '@/components';
import { useLazyGetReportingHomesListQuery } from '@/redux';
import { RtkqSpin } from '@/redux/rtkq';
import { useMemo } from 'react';
import { mapHomeLookup } from './useHomeLookupSource';

export function useReportingHomesLookupSource(
  clientId?: string | string[],
  communityId?: string | string[],
  projectId?: string | string[],
  withMenu?: boolean,
): LookupSource {
  const [fetchList] = useLazyGetReportingHomesListQuery();

  return useMemo(() => {
    const entireSource = createEntireLoadLookupSource({
      initial: (id: string) =>
        fetchList(
          { clientId, communityId, projectId, withMenu, [RtkqSpin]: false },
          true,
        )
          .unwrap()
          .then(
            (values) =>
              values
                .slice()
                .sort((a, b) =>
                  a.homeNumber.localeCompare(b.homeNumber, undefined, {
                    numeric: true,
                    sensitivity: 'base',
                  }),
                )
                .find((x) => x.id === id)!,
          )
          .then(mapHomeLookup),
      load: () =>
        fetchList(
          { clientId, communityId, projectId, withMenu, [RtkqSpin]: false },
          true,
        )
          .unwrap()
          .then((values) =>
            values
              .slice()
              .sort((a, b) =>
                a.homeNumber.localeCompare(b.homeNumber, undefined, {
                  numeric: true,
                  sensitivity: 'base',
                }),
              )
              .map(mapHomeLookup),
          ),
    });

    return { ...entireSource, searchField: '_search' };
  }, [fetchList, clientId, communityId, projectId, withMenu]);
}
